define('glu/grid/column/column',['require','../../$','../../collectionView','../row/row','../../model','../row/messageRow','../row/rowGroupHeader','../row/rowGroupModel','../row/rowSubViewWrapper','../../util','hbs!./subviewButton.hbs'],function(require) {
    'use strict';

    var $ = require('../../$'),
        CollectionView = require('../../collectionView'),
        RowView = require('../row/row'),
        Model = require('../../model'),
        MessageRowView = require('../row/messageRow'),
        RowGroupHeaderView = require('../row/rowGroupHeader'),
        RowGroupHeaderModel = require('../row/rowGroupModel'),
        RowSubViewWrapper = require('../row/rowSubViewWrapper'),
        util = require('../../util'),
        subviewButtonTemplate = require('hbs!./subviewButton.hbs');

    /**
     * Add wrapper around cell content for row subview animation
     * @param {jQuery} $cell
     * @returns {jQuery}
     */
    var addSubRowWrapper = function($cell) {
        $cell.wrapInner('<div />');
        return $cell.children('div');
    };

    return CollectionView.extend({
        initialize: function(opts) {

            this.grid = opts.grid;
            this.gridCid = opts.gridCid;
            this.editOptions = opts.editOptions;
            this.columns = opts.columns;
            this.rowClassName = opts.rowClassName;

            if (opts.groupBy) {
                this.groupByModel = new RowGroupHeaderModel(opts.groupBy);
            }

            this.debouncedGridContentRendered = util.debounce(util.bind(this.gridContentRendered, this), 0);
        },

        events: {
            'click .btn-grid-expand': 'toggleSubRow'
        },

        delegateEvents: function() {
            CollectionView.prototype.delegateEvents.apply(this, arguments);
            this.stopListening(this.collection, 'reset'); // prevent default CollectionView render on reset

            this.listenTo(this.columns, 'change:condition add remove sort sync', util.debounce(util.bind(this.handleChange, this), 5));

            // if we don't have groupBy or rowSubView feature enabled we should use built in Marionette CollectionView handlers for 'add' and 'remove' events
            if (!this.options.groupBy || !this.options.rowSubView) {
                this.listenTo(this.collection, 'reset sort sync', util.debounce(util.bind(this.handleChange, this), 5));
            } else {
                this.listenTo(this.collection, 'reset add remove sort sync', util.debounce(util.bind(this.handleChange, this), 5));
            }
        },

        itemView: RowView,

        prepend: function(view) {
            if (view.el.childNodes.length === 0) {
                view.render();
            }
            if (this.el.firstChild) {
                this.el.insertBefore(view.el, this.el.firstChild);
            } else {
                this.el.appendChild(view.el);
            }
        },

        append: function(view) {
            if (view.el.childNodes.length === 0) {
                view.render();
            }
            this.el.appendChild(view.el);
        },

        setLastView: function(view) {
            this.lastView = view;
        },

        setFirstView: function(view) {
            this.firstView = view;
        },

        onRender: function() {
            if (this.firstView) {
                this.prepend(this.firstView);
            }

            if (this.lastView) {
                this.append(this.lastView);
            }
            this.onDomRefresh();
        },

        onDomRefresh: function() {
            this.debouncedGridContentRendered();
        },

        gridContentRendered: function() {
            if (this.isClosed) {
                return;
            }
            this.grid.trigger('grid:contentRendered');
        },

        getRowSelector: function() {
            return this.columns.findWhere({
                type: 'rowSelector'
            });
        },

        getColumnCount: function() {
            var visibleColumns = this.columns.filter(function(column) {
                if (column.has('condition')) {
                    var isFunction = util.isFunction(column.get('condition')) && !column.get('condition')(this.model, column);
                    var isBoolean = util.isBoolean(column.get('condition')) && !column.get('condition');
                    if (isFunction || isBoolean) {
                        return false;
                    }
                }
                return true;
            }, this);

            return visibleColumns.length;
        },

        // Internal method to loop through each item in the
        // collection view and show it
        showCollection: function() {
            var columnCount = this.getColumnCount();

            // Necessary as cannot use :nth-child or :nth-of-type with sub row views
            var isEvenRow = false;

            this.collection.each(function(item, index) {
                var RowItemView = this.getItemView(item);

                this.addPreItemView(item, index, columnCount, isEvenRow);

                var view = this.addItemView(item, RowItemView, index);

                // Necessary when using sub-rows, as :nth-child/:nth-of-type isn't "class aware"
                view.el.className += isEvenRow ? ' grid-row grid-row-even' : ' grid-row grid-row-odd';

                this.addPostItemView(item, index, columnCount, view, isEvenRow);

                isEvenRow = !isEvenRow;
            }, this);

            // Reset value ready for next page of results.
            delete this.currentGroupByValue;
        },

        addPreItemView: function(item, index, columnCount, isEvenRow) {
            this.addRowGroupHeaderView(item, index, columnCount);
        },

        addPostItemView: function(item, index, columnCount, rowView, isEvenRow) {
            this.addSubRow(item, index, columnCount, rowView, isEvenRow);
            if (item.has('warning') || item.has('error')) {
                this.decorate(item, rowView);
            }
        },

        addSubRow: function(item, index, columnCount, rowView, isEvenRow) {
            if (!this.options.rowSubView) {
                return;
            }

            var RowSubView = this.options.rowSubView(item),
                id = util.uniqueId();

            if (!RowSubView) {
                return;
            }

            rowView.$('td:first').prepend(subviewButtonTemplate({
                id: id,
                disabled: !RowSubView
            }));

            if (!RowSubView) {
                rowView.$('.btn-grid-expand').attr('disabled', true);
                return;
            }

            var subRowModel = item.clone();

            subRowModel.set({
                columnCount: columnCount
            });

            var view = this.addItemView(subRowModel, RowSubViewWrapper, index);

            view.el.className += isEvenRow ? ' grid-subrow grid-row-even' : ' grid-subrow grid-row-odd';
            view.$el.attr('id', 'grid-subview-' + id); // for aria-controls association with button
            rowView.$('.btn-grid-expand').data('viewCid', view.cid); // for aria-controls association with button
        },

        toggleSubRow: function(e) {
            var $el = this.$(e.currentTarget),
                viewCid = $el.data('viewCid'),
                $nextRow = $el.closest('tr').next(),
                view = this.children.findByCid(viewCid),
                $subCell,
                $wrapper,
                rowIsHidden;

            // Fail fast
            if (!$nextRow.hasClass('grid-subrow')) {
                return;
            }

            $subCell = $nextRow.children().first();
            $wrapper = $subCell.children('div');

            // Wrapper is needed for the animation of table cell contents
            if ($wrapper.length === 0) {
                $wrapper = addSubRowWrapper($subCell);
            }

            rowIsHidden = $nextRow.hasClass('hidden');

            if (rowIsHidden) {

                // Turn off the hidden class & add
                // the zero-padding top/bottom "hidden-subrow-animate"
                $nextRow
                    .removeClass('hidden')
                    .addClass('hidden-subrow-animate');

                // Hide the data in the cells
                $wrapper.hide();

                // Remove the hidden-subrow-animate class to start the CSS transition
                // Also start the .slideDown()
                $nextRow.removeClass('hidden-subrow-animate');
                $wrapper.slideDown(500);

                if (view) {
                    view.triggerMethod('subRowExpanded');
                }
            } else {
                $nextRow.addClass('hidden-subrow-animate');
                $wrapper.slideUp(500, function() {
                    $nextRow.addClass('hidden').removeClass('hidden-subrow-animate');
                });
            }

            // Looks backwards, but if rowIsHidden *was* true above, expanded is now true
            $el.attr('aria-expanded', rowIsHidden);
        },

        addRowGroupHeaderView: function(item, index, columnCount) {
            if (!this.options.groupBy) {
                return;
            }

            var groupByValue = item.get(this.options.groupBy.field),
                groupByTitle = item.get(this.options.groupBy.titleField),
                hasRowSelector = this.getRowSelector();

            if (this.currentGroupByValue !== groupByValue) {
                this.groupByModel = new RowGroupHeaderModel(util.extend({
                    currentValue: groupByValue,
                    currentTitle: groupByTitle,
                    columnCount: columnCount,
                    hasRowSelector: hasRowSelector
                }, this.options.groupBy));
                this.groupId = this.groupByModel.cid;

                this.addItemView(this.groupByModel, RowGroupHeaderView, index);
                this.currentGroupByValue = groupByValue;
            }

            // Need to set 'groupId' property
            // silent is for prevent re-rendering
            item.set('groupId', this.groupId, {
                silent: true
            });
        },

        decorate: function(item, view) {
            var decorModel;

            if (item.has('error')) {
                decorModel = this.mapDecorModel(item, 'error');
            } else if (item.has('warning')) {
                decorModel = this.mapDecorModel(item, 'warning');
            }

            var decorView = this.createDecorView(decorModel, view.$('td').length);

            decorView.render();

            this.attachView(decorView, view);

            view.$el.addClass(decorModel.get('type') + '-content');

            decorView.$el.addClass(decorModel.get('type') + '-messages');

            this.children.add(decorView);
        },

        attachView: function(rowView, view) {
            if (view.el.nextSibling) {
                view.el.parentNode.insertBefore(rowView.el, view.el.nextSibling);
            } else {
                view.el.parentNode.appendChild(rowView.el);
            }
        },

        createDecorView: function(model, colspan) {
            var view = new MessageRowView({
                model: model,
                colspan: colspan
            });

            return view;
        },

        /**
         * Converts a warning or error message into a standardized model for easier template consumption.
         */
        mapDecorModel: function(model, type) {
            if (!model.has(type)) {
                return [];
            }
            var ret = {
                messages: []
            };
            var message = model.get(type);

            // REVIEW: Use util instead
            for (var key in message) {
                if (!message.hasOwnProperty(key)) {
                    return;
                }
                ret.type = type;
                ret.messages = ret.messages.concat(message[key]);
                ret.field = key;
            }
            return new Model(ret);
        },

        // TODO leave this method for backwards compatibility - remove in Glu 1.9
        setCollection: function(collection) {
            this.collection = collection;

            // if we don't have groupBy or rowSubView feature enabled we should use built in Marionette CollectionView collection events handling.
            if (!this.options.groupBy || !this.options.rowSubView) {
                if (this.collection) {
                    this.stopListening(this.collection, 'reset');
                }
                // We debounce this handler, because otherwise it is called as many times as there are models in the collection.
                return this.listenTo(this.collection, 'reset sort sync', util.debounce(util.bind(this.handleChange, this), 0));
            }

            if (this.collection) {
                this.stopListening(this.collection);
            }

            // We debounce this handler, because otherwise it is called as many times as there are models in the collection.
            this.listenTo(this.collection, 'reset add remove sort sync', util.debounce(util.bind(this.handleChange, this), 5));
        },

        handleChange: function(e) {
            if (this.isClosed) {
                return;
            }

            this.renderAndRestoreFocus();
            return e;
        },

        itemViewOptions: function(item) {
            return {
                columns: this.columns,
                rowClassName: this.rowClassName,
                editOptions: this.editOptions,
                gridCid: this.gridCid,
                grid: this.grid,
                RowSubView: util.isFunction(this.options.rowSubView) ? this.options.rowSubView(item) : undefined,
                rowSubViewOptions: this.options.rowSubViewOptions,
                disableDynamicColumnWidths: this.options.disableDynamicColumnWidths
            };
        },

        onClose: function() {
            if (this.firstView) {
                this.firstView.close();
            }
            if (this.lastView) {
                this.lastView.close();
            }
        }
    });
});

